const SEARCH_PARAMS = {
  ID: 'id',
  CUSTOM_FORM: 'customForm',
};

export { SEARCH_PARAMS };
